import React from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import TopNav from "../components/TopNav";
import { ConfirmProvider } from "../components/ConfirmDialog";

export default function Shell() {
  return (
    <div className="min-h-screen bg-[color:var(--kr-bg)] text-[color:var(--kr-ink)]">
      <TopNav />
      <main className="w-full">
        <Outlet />
      </main>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
